module.exports = " <div class=input-group _v-1f61a8ce=\"\"> <label _v-1f61a8ce=\"\">{{label}}</label> <slot _v-1f61a8ce=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-1f61a8ce!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/InputGroup.vue
// module id = 737
// module chunks = 2